import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=a7d02eec&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=a7d02eec&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7d02eec')) {
      api.createRecord('a7d02eec', component.options)
    } else {
      api.reload('a7d02eec', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=a7d02eec&", function () {
      api.rerender('a7d02eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/PL/components/detail.vue"
export default component.exports